import { atomWithReset } from 'jotai/utils'

import { type AllowedDomain } from './hooks/useMainQuery'

type AddDialogInfo = {
  dialogType: 'add'
}

type DeleteDialogInfo = {
  dialogType: 'delete'
  domain: AllowedDomain
}

type DialogInfo = AddDialogInfo | DeleteDialogInfo

export const dialogInfoAtom = atomWithReset<DialogInfo | null>(null)
